import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import api from "@/api";
import PageSections from "@/components/PageSections";

const CONTENT = {
  mr: {
    about_title: "RNVP म्हणजे काय?",
    about: "राष्ट्र निर्माण विद्यार्थी परिषद (RNVP) ही समता पार्टीची विद्यार्थी शाखा आहे, जी राष्ट्रीय अध्यक्ष श्री. उदय मंडल यांनी स्थापन केली. RNVP महाराष्ट्र राज्यातील विद्यार्थ्यांना राष्ट्र निर्माणाच्या कार्यात सहभागी करून घेते.",
    eligibility_title: "सदस्यत्वासाठी पात्रता",
    eligibility: [
      "अर्जदार विद्यार्थी असावा",
      "भारताचा नागरिक असावा",
      "इतर कोणत्याही राजकीय संघटनेचा सदस्य नसावा",
      "पूर्वी कोणत्याही गुन्ह्यात दोषी ठरलेला नसावा",
    ],
    categories_title: "सदस्यत्वाचे प्रकार",
    categories: [
      { name: "प्राथमिक सदस्य — A", desc: "नवीन सामील झालेले विद्यार्थी सदस्य" },
      { name: "सक्रिय सदस्य — B", desc: "संघटनात्मक कार्यात सक्रिय सहभाग घेणारे सदस्य" },
    ],
    join_cta: "RNVP मध्ये सामील व्हा",
  },
  hi: {
    about_title: "RNVP क्या है?",
    about: "राष्ट्र निर्माण विद्यार्थी परिषद (RNVP) समता पार्टी की छात्र शाखा है, जिसकी स्थापना राष्ट्रीय अध्यक्ष श्री उदय मंडल ने की। RNVP महाराष्ट्र राज्य के छात्रों को राष्ट्र निर्माण के कार्य में जोड़ती है।",
    eligibility_title: "सदस्यता के लिए पात्रता",
    eligibility: [
      "आवेदक छात्र होना चाहिए",
      "भारत का नागरिक होना चाहिए",
      "किसी अन्य राजनीतिक संगठन का सदस्य नहीं होना चाहिए",
      "पूर्व में किसी आपराधिक गतिविधि के लिए दोषी नहीं ठहरा होना चाहिए",
    ],
    categories_title: "सदस्यता की श्रेणियाँ",
    categories: [
      { name: "प्रारंभिक सदस्य — A", desc: "नए जुड़े छात्र सदस्य" },
      { name: "सक्रिय सदस्य — B", desc: "संगठनात्मक कार्य में सक्रिय भाग लेने वाले सदस्य" },
    ],
    join_cta: "RNVP से जुड़ें",
  },
  en: {
    about_title: "What is RNVP?",
    about: "The Rashtra Nirman Vidyarthi Parishad (RNVP) is the student wing of the Samata Party, founded by National President Shri Uday Mandal. RNVP Maharashtra engages students of the state in the work of nation building.",
    eligibility_title: "Membership Eligibility",
    eligibility: [
      "The applicant must be a student",
      "Must be a citizen of India",
      "Must not be part of any other political organization",
      "Must not have been convicted of any criminal activity in the past",
    ],
    categories_title: "Membership Categories",
    categories: [
      { name: "Initial Members — A", desc: "Newly joined student members" },
      { name: "Active Members — B", desc: "Members actively participating in organisational work" },
    ],
    join_cta: "Join RNVP",
  },
};

export default function RNVP() {
  const { t, lang } = useLang();
  const [serverBlocks, setServerBlocks] = useState(null);
  useEffect(() => {
    api.get("/pages/rnvp").then((r) => setServerBlocks(r.data.content?.[lang] || null)).catch(() => {});
  }, [lang]);
  const c = CONTENT[lang];
  const fallback = [
    { title: c.about_title, body: c.about },
    { title: c.eligibility_title, body: c.eligibility.map((e) => "- " + e).join("\n") },
    { title: c.categories_title, body: c.categories.map((x) => `- ${x.name}: ${x.desc}`).join("\n") },
  ];
  const blocks = serverBlocks || fallback;

  return (
    <div data-testid="rnvp-page">
      <section className="bg-emerald-950 text-white py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold" data-testid="rnvp-heading">{t.rnvp_title}</h1>
          <p className="text-amber-400 mt-2 italic">"{t.tagline}"</p>
        </div>
      </section>

      <PageSections blocks={blocks} testPrefix="rnvp" />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-14">
        <div className="bg-emerald-950 text-white rounded-2xl p-8 text-center">
          <img src="/logo.jpeg" alt="RNVP" className="w-20 h-20 rounded-full bg-white object-contain p-1 mx-auto mb-6" />
          <Link to="/membership" data-testid="rnvp-join-btn"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-amber-600 hover:bg-amber-700 font-bold transition-all hover:scale-105">
            {c.join_cta}
          </Link>
        </div>
      </section>
    </div>
  );
}
